import { useMemo } from "react";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

import KogCheckbox from "@/main/components/shared/checkbox/kogCheckbox";
import { isNullUndefined } from "@/main/services/utils";

import * as S from "./styles";
import RowItemRequoteOrderedClaim from "./rowItemRequoteOrderedClaim/rowItemRequoteOrderedClaim";
import { IRequoteClaim } from "../../modalRequoteClaim";
import { IItemFormRequoteSupplierOrdered } from "../../typesModalRequoteClaim";

interface IRowSupplierRequoteOrderedClaimProps {
	supplier: IItemFormRequoteSupplierOrdered;
	indexSupplier: number;
}
function RowSupplierRequoteOrderedClaim({ supplier, indexSupplier }: IRowSupplierRequoteOrderedClaimProps) {
	const { control, setValue } = useFormContext<IRequoteClaim>();

	useFieldArray({
		control,
		name: `sectionProcurement.suppliers.${indexSupplier}.items`,
	});
	const watcherFields = useWatch({
		control,
		name: `sectionProcurement.suppliers.${indexSupplier}.items`,
	});
	const controlledFields = watcherFields.map((field) => {
		return {
			...field,
		};
	});

	const allCheckboxesSelected = useMemo(() => {
		if (isNullUndefined(controlledFields)) return false;
		return controlledFields.every((item) => item.isSelected);
	}, [JSON.stringify(controlledFields)]);

	function handleToggleCheckboxAll() {
		const isAllCheckboxesSelected = controlledFields.every((item) => item.isSelected);
		controlledFields.forEach((item, index) => {
			setValue(`sectionProcurement.suppliers.${indexSupplier}.items.${index}.isSelected`, !isAllCheckboxesSelected);
		});
	}

	return (
		<S.Container>
			<S.HeaderSupplier onClick={() => handleToggleCheckboxAll()}>
				<S.TitleSupplier title={supplier.supplierName}> {supplier.supplierName}</S.TitleSupplier>
				<KogCheckbox
					checked={allCheckboxesSelected}
					value={allCheckboxesSelected}
					onChange={() => {
						handleToggleCheckboxAll();
					}}
				/>
			</S.HeaderSupplier>
			<S.BodySupplier>
				{controlledFields.map((item, index) => (
					<RowItemRequoteOrderedClaim
						key={item.procurementSupplierItemGuid}
						index={index}
						part={item}
						indexSupplier={indexSupplier}
					/>
				))}
			</S.BodySupplier>
		</S.Container>
	);
}

export default RowSupplierRequoteOrderedClaim;
